import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import de from '@/locales/de/common.json';
import en from '@/locales/en/common.json';

export const SUPPORTED_LANGUAGES = ['en', 'de'] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];


export const LANGUAGE_NAMES: Record<SupportedLanguage, string> = {
  en: 'English',
  de: 'Deutsch',
};

export function isSupportedLanguage(value: string): value is SupportedLanguage {
  return SUPPORTED_LANGUAGES.includes(value as SupportedLanguage);
}

/** The active language, resolved to one this app actually ships. */
export function activeLanguage(): SupportedLanguage {
  const [base = ''] = (i18n.language ?? '').split('-');
  return isSupportedLanguage(base) ? base : 'en';
}

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: en },
      de: { common: de },
    },
    defaultNS: 'common',
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES,
    interpolation: { escapeValue: false },
  });

/** Mirrors the active language onto `<html lang>`, where there is a document to carry it. */
function syncDocumentLanguage(): void {
  if (typeof document !== 'undefined') document.documentElement.lang = activeLanguage();
}

i18n.on('languageChanged', syncDocumentLanguage);

syncDocumentLanguage();

export default i18n;
